module.exports = __webpack_public_path__ + "img/page34.9300f589.gif";